import { __GetCampaignsPartner } from "./action-dto";

export default {
  getCampaignsPartner({ commit }: any, payload: __GetCampaignsPartner) {
    commit("GET_CAMPAIGNS_PARTNER", payload);
  },
}